module.exports = __webpack_public_path__ + "media/images/svg/clients/18-01829279d21f797eb9339624e445e8d8.svg";